export default "__VITE_ASSET__C8gpSfFs__"